export enum PricingSimulatorQueryEnum {
    FILTER_ATTRIBUTES = 'pricing-sim-filter-attributes',
    SCENARIO_STATUS = 'scenario-status',
    SCENARIO_DETAILS = 'ps-single-scenario-details',
    SCENARIO_LENS_DATA = 'ps-scenario-data',
}
